<ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-back-button [defaultHref]="getDefaultBackRoute()" (click)="handleBackNavigation($event)"></ion-back-button>
      </ion-buttons>
      <ion-title>{{'Generate Partner Token' | translate}}</ion-title>
      <ion-buttons slot="end">
        <ion-button [routerLink]="['/manage-tokens']">
          <ion-icon name="list-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

<ion-content>
<div class="content-width">
  <ion-card>
    <ion-card-header>
      <ion-card-title>{{'Generate New Partner Token' | translate}}</ion-card-title>
      <!-- <ion-card-subtitle>Create a new token for partner access</ion-card-subtitle> -->
    </ion-card-header>

    <ion-card-content>
      <form [formGroup]="tokenForm" (ngSubmit)="generateToken()">
        
        <!-- Publisher Filter (Admin Only) -->
        <ion-item *ngIf="isAdmin" button (click)="openPublisherFilter($event)">
          <ion-label position="stacked">{{'Publisher' | translate}}</ion-label>
          <ion-label slot="end" class="filter-value">
            {{ getSelectedPublisherLabel() }}
            <ion-icon name="chevron-down-outline" slot="end"></ion-icon>
          </ion-label>
        </ion-item>

        <!-- Partner Name Selection -->
        <ion-item>
          <ion-label position="stacked">{{'Partner Name' | translate}} *</ion-label>
          
          <!-- Toggle button for role 500+ users -->
          <ion-button 
            *ngIf="authService.authUserSignal()?.role.value >= 500"
            fill="clear" 
            size="small" 
            (click)="togglePartnerInput()"
            slot="end">
            <ion-icon [name]="isCustomPartner ? 'list-outline' : 'create-outline'"></ion-icon>
            {{ isCustomPartner ? 'Select from list' : 'Enter custom' | translate }}
          </ion-button>
        </ion-item>

        <!-- Popover-based partner selection -->
        <ion-item *ngIf="!isCustomPartner" button (click)="openPartnerNameFilter($event)">
          <ion-label slot="end" class="filter-value">
            {{ getSelectedPartnerNameLabel() }}
            <ion-icon name="chevron-down-outline" slot="end"></ion-icon>
          </ion-label>
          <ion-spinner *ngIf="isLoadingPartners" name="crescent" slot="end"></ion-spinner>
        </ion-item>

        <!-- Custom input for new partner names -->
        <ion-item *ngIf="isCustomPartner">
          <ion-input 
            formControlName="partnerName"
            placeholder="{{'Enter partner name (no spaces allowed)' | translate}}"
            (ionInput)="onPartnerNameInput($event)">
          </ion-input>
          <!-- <ion-icon name="information-circle-outline" slot="end" color="primary"></ion-icon> -->
        </ion-item>
        
        <!-- Show selected publisher for custom partner (Admin Only) -->
        <ion-item *ngIf="isCustomPartner && isAdmin && selectedPublisher">
          <ion-label>
            <ion-icon name="information-circle-outline" slot="start"></ion-icon>
            {{'Custom partner will be associated with' | translate}}: <b>{{ getSelectedPublisherLabel() }}</b>
          </ion-label>
        </ion-item>

        <!-- Validation error for spaces -->
        <ion-item *ngIf="tokenForm.get('partnerName')?.errors?.hasSpaces" class="error-item">
          <ion-label color="danger">
            <ion-icon name="alert-circle-outline" slot="start"></ion-icon>
            {{'Partner name cannot contain spaces. Use hyphens instead.' | translate}}
          </ion-label>
        </ion-item>
        
        <!-- Show message when no partners available -->
        <ion-item *ngIf="!isLoadingPartners && partnerNames.length === 0 && !isCustomPartner" class="no-partners">
          <ion-label color="warning">
            <ion-icon name="warning-outline" slot="start"></ion-icon>
            {{'No partners available. Please contact your administrator.' | translate}}
          </ion-label>
        </ion-item>

        <!-- Alternative: Text input for partner name -->
        <!-- <ion-item>
          <ion-label position="stacked">{{'Partner Name' | translate}} *</ion-label>
          <ion-input 
            formControlName="partnerName" 
            placeholder="{{'Enter partner name' | translate}}"
            (ionInput)="onPartnerNameInput($event)">
          </ion-input>
        </ion-item> -->

        <!-- Expiry Date -->
        <ion-item>
          <ion-label position="stacked">{{'Expiry Date' | translate}}  *</ion-label>
          <ion-input 
            readonly 
            [value]="getFormattedDate()"
            placeholder="{{'Select expiry date' | translate}}"
            (click)="openDatePicker()"
            [disabled]="isLoading">
          </ion-input>
          <!-- <ion-icon name="calendar-outline" slot="end" color="primary"></ion-icon> -->
        </ion-item>

        <ion-popover #datePopover [keepContentsMounted]="true">
          <ng-template>
            <ion-datetime
              [presentation]="'date'"
              [min]="getMinDate()"
              [max]="getMaxDate()"
              [showDefaultButtons]="true"
              [value]="tokenForm.get('expiryDate')?.value"
              (ionChange)="onDateChange($event)">
            </ion-datetime>
          </ng-template>
        </ion-popover>

        

        <!-- Generate Button -->
        <ion-button 
          type="submit" 
          expand="block" 
          [disabled]="tokenForm.invalid || isLoading"
          class="ion-margin-top">
          <ion-spinner *ngIf="isLoading" name="crescent"></ion-spinner>
          <ion-icon *ngIf="!isLoading" name="key-outline" slot="start"></ion-icon>
          {{ isLoading ? 'Generating...' : 'Generate Token' | translate }}
        </ion-button>

      </form>
    </ion-card-content>
  </ion-card>

  <!-- Manage Tokens Link -->
  <ion-card>
    <ion-card-content>
      <ion-button 
        [routerLink]="['/manage-tokens']" 
        fill="clear" 
        expand="block"
        class="ion-margin-top">
        <ion-icon name="list-outline" slot="start"></ion-icon>
        {{'Manage Existing Tokens' | translate}} 
      </ion-button>
    </ion-card-content>
  </ion-card>
</div>
</ion-content> 